import axios from 'axios';
import authHeader from '../auth-header'
import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/all/";

const getLogActivity = 'log-activity';

class LogActivityService {
    
    getLogActivity(currentPage, pageSize, filter) {

        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
        };
        
        return axios.get(
            API_URL + getLogActivity ,
        {
            params : data,
            headers: authHeader()
        });
    }

}

export default new LogActivityService();